<template>
    <transition name="fade" appear>
        <div v-if="loaded" class="zoom-image">
            <div ref="imageWrapper" class="image-wrapper">
                <img ref="image" :src="image">
            </div>
            <div class="caption">
                <slot />
            </div>
            <ScrollBarX
                ref="scrollBar"
                v-model="scaleOffset"
                :active="true"
                :with-buttons="true"
            />
        </div>
    </transition>
</template>

<script>
import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
import {InertiaPlugin} from '@/static/InertiaPlugin';
import ImageLoader from '@kids/lib/class/ImageLoader';
import responder from '@kids/lib/service/responder';

gsap.registerPlugin(InertiaPlugin);

const {Math} = globalThis;

export default {
    name: 'ZoomImage',
    props: {
        image: {
            type: String,
            required: true
        }
    },
    data: () => ({
        scaleOffset: 0,
        loaded: false
    }),
    watch: {
        scaleOffset(val, oldVal)
        {
            const scale = 1 + (val * 1.5);
            const duration = Math.abs(val - oldVal) < 0.19 ? 0 : 0.3;
            gsap.to(
                this.$refs.image,
                {
                    scale,
                    duration,
                    onUpdate: () => this._draggable.applyBounds()
                }
            );
        }
    },
    mounted()
    {
        new ImageLoader(this.image).loaded.then(this.loadedHandler);
        responder.on('resize', this.resize);
    },
    destroyed()
    {
        if (this._draggable)
        {
            this._draggable.kill();
        }
        responder.on('resize', this.resize);
    },
    methods: {
        loadedHandler()
        {
            this.loaded = true;
            this.$nextTick(() =>
            {
                [this._draggable] = Draggable.create(
                    this.$refs.image,
                    {
                        type: 'x,y',
                        inertia: true,
                        bounds: this.$refs.imageWrapper,
                        edgeResistance: 0.85
                    }
                );
            });
        },
        resize()
        {
            if (!this._draggable) { return; }
            this._draggable.applyBounds();
        }
    }
};
</script>

<style lang="scss" src="./ZoomImage.scss" />
